import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Modal, Breadcrumb, Typography, Spin, Select } from 'antd';
import { formItemLayout, tailFormItemLayout } from '../../../common_functions';

const Park = props => {
  const { section, id } = useParams();
  const [location, setLocation] = useState({});
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState([]);
  const formRef = useRef(null);
  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        let { data: stateData } = await props.getItems('states', { fields: ['id,state'], limit: '-1', sort: 'state' });
        setStates(stateData);
        if (id !== 'new') {
          let { data } = await props.getItem('parks', id);
          setLocation(data);
          formRef.current.setFieldsValue(data);
        }
      } catch (error) {
        Modal.warning({
          title: 'Error',
          content: 'Unexpected error occured',
        });
      }
      setLoading(false);
    }
    fetchData();
  }, [section, id]);

  let onFinish = values => {
    setLoading(true);
    let newState = { ...location, ...values };
    props
      .saveItem('parks', newState)
      .then(
        response => {
          setLoading(false);
          if (response) {
            notification['success']({
              message: 'Park saved successfully!',
              duration: 2,
            });
            setTimeout(() => props.history.push('/settings/parks', 1500));
          }
        },
        errorReponse => {
          if (errorReponse.errors !== undefined) {
            for (var i = 0; i < errorReponse.errors.length; i++) {
              var errorObj = errorReponse.errors[i];
              var errorField = errorObj.extensions.field;
              var errorFieldMessage = errorObj.message;
              formRef.current.setFields([
                {
                  name: errorField,
                  errors: [errorFieldMessage],
                },
              ]);
            }
          } else {
            Modal.warning({
              title: 'Error',
              content: 'Unexpected error occured',
            });
          }
        }
      )
      .catch(error => {
        setLoading(false);
        Modal.warning({
          title: 'Error',
          content: 'Not Saved!',
        });
      });
    setLoading(false);
  };
  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };
  let backButton = () => {
    setTimeout(() => props.history.push('/settings/parks', 1500));
  };
  return (
    <>
      <Spin spinning={loading} size="large">
        <Row>
          <Col className="app-breadcrumb-col">
            <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/parks" }, { title: "Parks", href: "/settings/parks" }, { title: id != 'new' ? `Edit Park` : 'Add Park' }]} />
          </Col>
          <Col className="white-paper">
            <Row gutter={24} className="page-header-section" align="middle">
              <Col xs={12}>
                <Typography.Title level={4} style={{ margin: 0 }}>
                  {id != 'new' ? `Edit Park: ${id}` : 'Add Park'}
                </Typography.Title>
              </Col>
              <Col xs={12} justify="end"></Col>
            </Row>
            <hr />
            <div className="artist">
              <Form
                ref={formRef}
                layout="vertical"
                {...formItemLayout}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{ layout: tailFormItemLayout }}
              >
                <Row gutter={24}>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="state"
                      label="State"
                      rules={[
                        {
                          required: true,
                          message: 'State is required!',
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select State"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                        style={{ textTransform: 'capitalize' }}
                      >
                        {states.map(item => {
                          return (
                            <Option key={item.id} value={item.id} style={{ textTransform: 'capitalize' }}>
                              {item.state}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="park"
                      label="Park/Monument/Wilderness/etc"
                      rules={[
                        {
                          whitespace: true,
                          required: true,
                          message: 'Park/Monument/Wilderness/etc is required!',
                        },
                      ]}
                    >
                      <Input placeholder="Enter park/monument/wilderness/etc" />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item {...tailFormItemLayout}>
                  <Button
                    type="default"
                    htmlType="button"
                    onClick={backButton}
                    style={{
                      borderColor: '#d9d9d9',
                      background: '#f5f5f5',
                      color: 'rgba(0, 0, 0, 0.85)',
                    }}
                  >
                    Back
                  </Button>
                  {props.showButton(props.roleType, props.tabs_permissions.settings_parks, !!location ? location.id : '')}
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      </Spin>
    </>
  );
};

export default Park;
